module.exports = __webpack_public_path__ + "static/media/arrow-up.e2e25144.svg";